import { render, staticRenderFns } from "./company-documents-header.vue?vue&type=template&id=6e727502&"
import script from "./company-documents-header.vue?vue&type=script&lang=js&"
export * from "./company-documents-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports